import { API, PATH } from 'data';
import { __PostsFiltersType, __PostSearchParamsType } from './posts.type';
import { nextBrowser } from 'scripts';
import { CategoryHierarchyType, CategoryType, LocationType } from 'types';

export const __PostsPageURL = (filters: __PostsFiltersType): URL => {
    const params: { [key: string]: string } = {};
    if (filters.page && filters.page !== 1) params.page = filters.page.toString();
    if (filters.search) params.search = filters.search;
    if (filters.category) params.category = filters.category.slug;
    const path = new URL((process.env.NEXT_PUBLIC_HOST ?? nextBrowser?.window?.location.origin ?? '') + PATH.posts());
    Object.entries(params).map((item) => path.searchParams.append(item[0], item[1]));
    filters.categoryFields?.map((f) => path.searchParams.append(`category_field[${f.id}]`, f.value.toString()));
    filters.ranges?.map((f) => path.searchParams.append(`range_category_field[${f.id}]`, f.value.toString()));
    return path;
};

export const __GetParentCategories = (categories?: CategoryHierarchyType[]): CategoryType<'list'>[] => {
    if (!categories) return [];
    return categories.map((item) => ({
        id: item.id,
        title: item.title,
        slug: item.slug,
        image: item.image,
        price: item.price,
        parent: item.parent,
        icon: item.icon,
        renewed_price: item.renewed_price,
    }));
};

const extractListParams = (e: object): Pick<__PostsFiltersType, 'categoryFields' | 'ranges'> => {
    const categoryFields: { id: number; value: number }[] = [];
    const ranges: { id: number; value: [number, number] }[] = [];
    Object.entries(e).map((item) => {
        // ^.*?range_category_field\[[^\d]*(\d+)[^\d]*\].*$
        if (/^.*?\[[^\d]*(\d+)[^\d]*\].*$/.test(item[0])) {
            // search param item has bracket: { category_filed[id]: value }
            const regID = /\[[^\d]*(\d+)[^\d]*\]/.exec(item[0]);
            if (regID && regID.length > 1) {
                const id = regID[1];
                if (item[0].toString().includes('range')) {
                    if (Array.isArray(item[1]))
                        item[1].map((i) => ranges.push({ id: Number(id), value: i.split(',') }));
                    else ranges.push({ id: Number(id), value: item[1].split(',') });
                } else {
                    if (Array.isArray(item[1]))
                        item[1].map((i) => categoryFields.push({ id: Number(id), value: Number(i) }));
                    else categoryFields.push({ id: Number(id), value: Number(item[1]) });
                }
            }
        }
    });
    return { categoryFields, ranges };
};

export const __ConvertSearchToFilter = (
    e: __PostSearchParamsType,
    category?: CategoryType<'detail'>,
): __PostsFiltersType => {
    const { categoryFields, ranges } = extractListParams(e);
    return {
        page: e.page,
        search: e.search,
        categoryFields,
        ranges,
        category: category
            ? {
                  id: category.id,
                  title: category.title,
                  slug: category.slug,
                  image: category.image,
                  price: category.price,
                  parent: category.parent?.id,
                  renewed_price: category.renewed_price,
              }
            : undefined,
    };
};

export const __PostFetchServerURL = (e: __PostSearchParamsType, location?: LocationType<'list'>[]) => {
    const params = new URLSearchParams();
    params.append('page_size', '36');
    params.append('ordering', '-renewed_at');
    if (location) params.append('location_descendants__in', location.map((i) => i.id).toString());
    if (e.page) params.append('page', e.page.toString());
    if (e.search) params.append('title__icontains', e.search.toString());
    if (e.category) params.append('category_slug_descendants', e.category);
    const { categoryFields, ranges } = extractListParams(e);
    if (categoryFields?.length) categoryFields.map((f) => params.append(`category_field[${f.id}]`, f.value.toString()));
    if (ranges?.length) ranges.map((f) => params.append(`range_category_field[${f.id}]`, f.value.toString()));
    return API.posts.list + (params.toString().length ? '?' + params.toString() : '');
};

export const __PostFetchURL = (e: __PostsFiltersType, location?: LocationType<'list'>[]) => {
    const params = new URLSearchParams();
    params.append('page_size', '36');
    params.append('ordering', '-renewed_at');
    if (location) params.append('location_descendants__in', location.map((i) => i.id).toString());
    if (e.page) params.append('page', e.page.toString());
    if (e.search) params.append('title__icontains', e.search.toString());
    if (e.category) params.append('category_slug_descendants', e.category.slug);
    if (e.categoryFields?.length)
        e.categoryFields.map((f) => params.append(`category_field[${f.id}]`, f.value.toString()));
    if (e.ranges?.length) e.ranges.map((f) => params.append(`range_category_field[${f.id}]`, f.value.toString()));
    return API.posts.list + (params.toString().length ? '?' + params.toString() : '');
};
